
import { UserCircle, CheckCircle2, ClipboardList, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Link } from "react-router-dom";

interface ProfileTask {
  id: number;
  task: string;
  completed: boolean;
}

const ProfileCompletionCard = () => {
  // Profile completion tasks that need to be done
  const pendingProfileTasks: ProfileTask[] = [
    { id: 1, task: "Complete your business information", completed: false },
    { id: 2, task: "Verify your phone number", completed: true },
    { id: 3, task: "Add payment details", completed: false },
    { id: 4, task: "Set communication preferences", completed: false }
  ];
  
  const completedTaskCount = pendingProfileTasks.filter(task => task.completed).length;
  const completionPercentage = Math.round((completedTaskCount / pendingProfileTasks.length) * 100);

  return (
    <Card className="border-l-4 border-l-propertylk-blue">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <UserCircle className="h-5 w-5 text-propertylk-blue" />
            Complete Your Profile
          </CardTitle>
          <span className="text-sm font-medium">{completionPercentage}% complete</span>
        </div>
        <CardDescription>
          Finish these tasks to improve visibility and build trust with potential clients
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mb-4">
          <Progress value={completionPercentage} className="h-2" />
        </div>
        <div className="space-y-3">
          {pendingProfileTasks.map(task => (
            <div key={task.id} className="flex items-start gap-3">
              <div className={`mt-0.5 h-5 w-5 rounded-full flex items-center justify-center flex-shrink-0 ${
                task.completed ? "bg-green-100" : "bg-amber-100"
              }`}>
                {task.completed ? (
                  <CheckCircle2 className="h-4 w-4 text-green-600" />
                ) : (
                  <ClipboardList className="h-4 w-4 text-amber-600" />
                )}
              </div>
              <span className={task.completed ? "text-muted-foreground line-through" : ""}>{task.task}</span>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="outline" className="w-full" asChild>
          <Link to="/dashboard/profile">
            Complete Profile
            <ChevronRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ProfileCompletionCard;
